<template>
    <div :style="skin.btn_lang?.text ?? 'color:#fff'" >
        <div class="header-desktop__set-language" v-if="movil == 'desktop'">
            <div class="set-language-desktop set-language-desktop_open" :style="skin?.btn_lang?.fondo">
                <div class="set-language-desktop__current" @click="toggleopen()" :style="skin.my_account.search">
                    <svg style="width: 1.375rem;height: 1.375rem;margin-right: .625rem;" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_11402_11005)">
                            <path opacity="0.975" fill-rule="evenodd" clip-rule="evenodd"
                                d="M10.9453 -0.0234375C11.6328 -0.0234375 12.3203 -0.0234375 13.0078 -0.0234375C17.4322 0.519309 20.69 2.75369 22.7812 6.67969C23.4218 8.03948 23.8203 9.46139 23.9766 10.9453C23.9766 11.6328 23.9766 12.3203 23.9766 13.0078C23.4338 17.4322 21.1995 20.69 17.2734 22.7812C15.9136 23.4218 14.4917 23.8203 13.0078 23.9766C12.3203 23.9766 11.6328 23.9766 10.9453 23.9766C6.52097 23.4338 3.26313 21.1995 1.17188 17.2734C0.5313 15.9136 0.132861 14.4917 -0.0234375 13.0078C-0.0234375 12.3203 -0.0234375 11.6328 -0.0234375 10.9453C0.519309 6.52097 2.75369 3.26313 6.67969 1.17188C8.03948 0.5313 9.46139 0.132861 10.9453 -0.0234375ZM11.2266 1.52344C11.2733 2.85915 11.289 4.2029 11.2734 5.55469C10.2476 5.53491 9.23198 5.42555 8.22656 5.22656C8.69569 3.98208 9.41447 2.91176 10.3828 2.01562C10.6486 1.81904 10.9299 1.65497 11.2266 1.52344ZM12.6797 1.52344C13.3479 1.79287 13.9026 2.21474 14.3438 2.78906C14.9128 3.53604 15.3737 4.34854 15.7266 5.22656C14.7211 5.42555 13.7055 5.53491 12.6797 5.55469C12.6797 4.21094 12.6797 2.86719 12.6797 1.52344ZM8.22656 2.08594C8.27461 2.10453 8.28244 2.13578 8.25 2.17969C7.63078 3.00367 7.13859 3.9021 6.77344 4.875C6.08934 4.75116 5.43309 4.53239 4.80469 4.21875C5.81119 3.29358 6.9518 2.58264 8.22656 2.08594ZM15.6797 2.08594C16.979 2.57116 18.1352 3.2821 19.1484 4.21875C18.52 4.53239 17.8638 4.75116 17.1797 4.875C16.9599 4.38073 16.7333 3.88854 16.5 3.39844C16.2373 2.95042 15.9638 2.51293 15.6797 2.08594ZM3.72656 5.36719C4.52706 5.74088 5.35519 6.04556 6.21094 6.28125C6.25444 6.29944 6.2857 6.3307 6.30469 6.375C5.87269 7.97944 5.63831 9.61223 5.60156 11.2734C4.21094 11.2734 2.82031 11.2734 1.42969 11.2734C1.60757 9.06661 2.37319 7.09786 3.72656 5.36719ZM20.1328 5.36719C20.2039 5.3677 20.2586 5.39892 20.2969 5.46094C21.6052 7.17398 22.3474 9.11147 22.5234 11.2734C21.1328 11.2734 19.7422 11.2734 18.3516 11.2734C18.3148 9.61223 18.0804 7.97944 17.6484 6.375C17.6674 6.3307 17.6987 6.29944 17.7422 6.28125C18.578 6.06281 19.3749 5.75812 20.1328 5.36719ZM7.75781 6.63281C8.91741 6.86466 10.0893 6.98967 11.2734 7.00781C11.2734 8.42967 11.2734 9.85158 11.2734 11.2734C9.86719 11.2734 8.46094 11.2734 7.05469 11.2734C7.08605 9.69389 7.32042 8.14702 7.75781 6.63281ZM16.1016 6.63281C16.1483 6.62878 16.1873 6.64444 16.2188 6.67969C16.6371 8.18255 16.8637 9.71381 16.8984 11.2734C15.4922 11.2734 14.0859 11.2734 12.6797 11.2734C12.6797 9.85158 12.6797 8.42967 12.6797 7.00781C13.8391 6.99487 14.9798 6.86986 16.1016 6.63281ZM1.42969 12.6797C2.82031 12.6797 4.21094 12.6797 5.60156 12.6797C5.63831 14.3409 5.87269 15.9737 6.30469 17.5781C6.2857 17.6224 6.25444 17.6537 6.21094 17.6719C5.36808 17.8981 4.55557 18.2028 3.77344 18.5859C2.37864 16.8721 1.59739 14.9033 1.42969 12.6797ZM7.05469 12.6797C8.46094 12.6797 9.86719 12.6797 11.2734 12.6797C11.2734 14.1015 11.2734 15.5235 11.2734 16.9453C10.1046 16.9606 8.94834 17.0857 7.80469 17.3203C7.77722 17.3105 7.75378 17.2949 7.73438 17.2734C7.31606 15.7706 7.08947 14.2393 7.05469 12.6797ZM12.6797 12.6797C14.0859 12.6797 15.4922 12.6797 16.8984 12.6797C16.8637 14.2393 16.6371 15.7706 16.2188 17.2734C16.1993 17.2949 16.1759 17.3105 16.1484 17.3203C15.0048 17.0857 13.8485 16.9606 12.6797 16.9453C12.6797 15.5235 12.6797 14.1015 12.6797 12.6797ZM18.3516 12.6797C19.7422 12.6797 21.1328 12.6797 22.5234 12.6797C22.3558 14.9032 21.5745 16.872 20.1797 18.5859C19.3976 18.2028 18.585 17.8981 17.7422 17.6719C17.6987 17.6537 17.6674 17.6224 17.6484 17.5781C18.0804 15.9737 18.3148 14.3409 18.3516 12.6797ZM10.5703 18.3984C10.8047 18.3984 11.0391 18.3984 11.2734 18.3984C11.2813 19.7423 11.2734 21.086 11.25 22.4297C10.5949 22.1497 10.048 21.7279 9.60938 21.1641C9.04036 20.4171 8.57944 19.6046 8.22656 18.7266C9.00872 18.5781 9.78994 18.4688 10.5703 18.3984ZM12.6797 18.3984C13.7055 18.4182 14.7211 18.5276 15.7266 18.7266C15.2574 19.971 14.5387 21.0413 13.5703 21.9375C13.3044 22.1406 13.0153 22.3047 12.7031 22.4297C12.6797 21.086 12.6719 19.7423 12.6797 18.3984ZM6.63281 19.0547C6.69478 19.0467 6.74948 19.0623 6.79688 19.1016C7.1482 20.0702 7.63256 20.9608 8.25 21.7734C8.28127 21.8047 8.28127 21.8359 8.25 21.8672C6.9608 21.3754 5.81236 20.6644 4.80469 19.7344C5.39981 19.4554 6.00919 19.2289 6.63281 19.0547ZM17.1797 19.0547C17.8631 19.2018 18.5193 19.4283 19.1484 19.7344C18.1408 20.6644 16.9923 21.3754 15.7031 21.8672C15.9653 21.4384 16.2309 21.0008 16.5 20.5547C16.7401 20.059 16.9666 19.559 17.1797 19.0547Z"
                                :fill="skin?.btn_lang?.icon ?? '#ccc'"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_11402_11005">
                                <rect width="24" height="24" fill="white"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                    <svg style="width: 1.125rem;height: 1.125rem;" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.14463 7.5C5.72276 7.5 5.51182 8.01562 5.81651 8.32031L8.81651 11.3203C9.00401 11.5078 9.3087 11.5078 9.4962 11.3203L12.4962 8.32031C12.8009 8.01562 12.5899 7.5 12.1681 7.5H6.14463Z"
                            fill="white"></path>
                    </svg>
                </div>
                <div v-if="open" class="set-language-desktop__items set-language-desktop__items_open" :style="skin.my_account.search">
                    <div class="set-language-desktop__item" v-for="(lang, index) in Object.keys(skin.languages)"
                        :style="lang == getLanguage ? skin?.btn_lang?.selection : ''"
                        @click="change_language(lang)">
                        <img :src="require(`@/assets/images/${lang}.png`)" alt=""
                            style="width: 1.5rem;height: 1.5rem;margin-right: .625rem;">
                        <span>{{ skin.languages[lang].name.split('-')[1].trim() }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="set-language-mobile" v-if="movil == 'mobile'">
            <div class="set-language-mobile__container">
                <div class="set-language-mobile__current-item" @click="toggleopen()" :style="skin.my_account.search">
                    <div style="display: flex;align-items: center;">
                        <img :src="require(`@/assets/images/${getLanguage}.png`)" alt=""
                            style="width: 1.5rem;height: 1.5rem;margin-right: .625rem;">
                        <span>{{ skin.languages[getLanguage].name.split('-')[1].trim() }}</span>
                    </div>
                    <div style="width: 1.875rem;height: 1.875rem;justify-self: flex-end;" :style="{ transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }">
                        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.2888 14.5321L13.1667 9.19266C13.0435 9.06422 12.8938 9 12.7178 9C12.5418 9 12.3922 9.06422 12.269 9.19266L11.6881 9.79817C11.5649 9.92661 11.5033 10.0826 11.5033 10.2661C11.4857 10.4495 11.5385 10.6055 11.6617 10.7339L15.7541 15L11.6617 19.2661C11.5385 19.3945 11.4857 19.5505 11.5033 19.7339C11.5033 19.9174 11.5649 20.0734 11.6881 20.2018L12.269 20.8073C12.3922 20.9358 12.5418 21 12.7178 21C12.8938 21 13.0435 20.9358 13.1667 20.8073L18.2888 15.4679C18.4296 15.3394 18.5 15.1835 18.5 15C18.5 14.8165 18.4296 14.6606 18.2888 14.5321Z"
                                fill="white"></path>
                        </svg>
                    </div>
                </div>
                <div class="set-language-mobile__items" v-if="open" v-for="(lang, index) in filteredLanguages"
                    :style="{ top: ((index+1) * 100) + '%' }" @click="change_language(lang)">
                    <div  class="set-language-mobile__item":style="skin.my_account.search">
                        <img :src="require(`@/assets/images/${lang}.png`)" alt=""
                            style="width: 1.5rem;height: 1.5rem;margin-right: .625rem;">
                        <span>{{ skin.languages[lang].name.split('-')[1].trim() }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "language_selector",
    props: ['skin', 'language', 'movil'],
    data() {
        return {
            open: false,
        }
    },
    methods: {
        change_language(lg) {
            this.$store.dispatch('setLanguage', lg);
            this.toggleopen();
        },
        toggleopen() {
            this.open = !this.open;
        },
    },
    computed: {
        ...mapGetters(['getLanguage']),
        filteredLanguages() {
    return Object.keys(this.skin.languages).filter(lang => lang !== this.getLanguage);
  }
    }
}
</script>

<style>
.header-desktop__set-language {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: .875rem;
}

.set-language-desktop {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
    border-radius: 6.25rem;
    padding: 1px;
    z-index: 5;
}

.set-language-desktop__current {
    height: 2.5rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    width: 100%;
    padding: 0 .625rem 0 .938rem;
    border-radius: 6.25rem;
}

.set-language-desktop__items {
    opacity: 0;
    max-height: 0rem;
    position: absolute;
    z-index: 3;
    bottom: -7.5rem;
    right: 0;
    border-radius: .625rem;
    overflow: hidden;
}

.set-language-desktop_open .set-language-desktop__items {
    -webkit-animation: incraseVertical .3s linear forwards;
    animation: incraseVertical .3s linear forwards;
}

@keyframes incraseVertical {
    from {
        max-height: 0;
        opacity: 0;
    }

    to {
        max-height: 500px;
        opacity: 1;
    }
}

.set-language-desktop__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 2.25rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: .375rem 1.313rem .375rem .625rem;
    cursor: pointer;
}

.set-language-desktop__item_selected {
    background: linear-gradient(113.27deg, #5428b4 15.04%, #b339e2 84.96%);
}

.set-language-mobile {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 2.75rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: .875rem;
}

.set-language-mobile__container {
    min-width: 10rem;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    width: 100%;
}

.set-language-mobile__current-item {
    width: 100%;
    height: 100%;
    margin-bottom: 2px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    border-radius: 31.25rem;
    padding: 0 1.25rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.set-language-mobile__items {
    width: 100%;
    display: block;
    position: absolute;
    right: 0;
    top: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 999;
}

.set-language-mobile__item {
    width: 100%;
    height: 2.75rem;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    padding: 0 1.25rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 31.25rem;
}
</style>